import FormflowComponentsModal from '@components/FormFlow/FormflowComponentsModal';
import IBaseComponent from '@components/FormFlow/Interfaces/Base/IBaseComponent';
import ISection from '@components/FormFlow/Interfaces/ISection';
import ISectionCondition from '@components/FormFlow/Interfaces/ISectionCondition';
import IProcess from '@components/FormFlow/Interfaces/Process';
import SectionComponent from '@components/FormFlow/SectionComponent';
import FormflowContext from '@components/FormFlow/Util/FormflowContext';
import Page from '@components/Page';
import QuillHtmlComponent from '@components/QuillHtmlEditorComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Frequency, FrequencyType, IProcess as IProcessEHSS } from '@interfaces/ehss/Process';
import { Pillar, PillarNames } from '@interfaces/pillar';
import UserService from '@services/UserService';
import { Routes } from '@src/helpers/_routes';
import NotificationComponent from '@src/helpers/_showNotifications';
import ProcessRequestsInterceptor from '@src/helpers/interceptors/ProcessRequestInterceptor';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Button, Form, Icon, Input, InputNumber, Radio, Row } from 'antd';
import React from 'react';
import { Redirect } from 'react-router-dom';

import { LocalStorageKeys } from '../../containers/App';


const FormItem = Form.Item;
interface IFormflowContainerProps {
  match: any
  form: any
}
interface IFormflowContainerState {
  currentComponent: IBaseComponent | null,
  currentSection: ISection | null,
  footerShow: boolean;
  formflow: IProcess,
  formflowSections: ISection[],
  isComponentModalOpen: boolean;
  isLoaded: boolean,
  linkedModalVisible: boolean;
  quillContent?: any;
  sectionsSize?: number;
  title: string;
  updateComponent: IBaseComponent | null,
  valueRadio: number;
  visibleModalRemoveSection: boolean;
  modalConditionVisible?: boolean;
  isSaved: boolean;
  conditionIsBroken: boolean;
  redirect: boolean;

  minAuditedsByAuditor?: any;
  maxAuditedsByAuditor?: any;
  auditorGoal: Frequency;
  auditedGoal: Frequency;

  tableUsers: any;
  curOffset?: string;
  searchUser?: string;

};
// In case of a new formflow
export class Formflow implements IProcess {
  name: string;
  sections: ISection[];
  version: number;
  units: string[];
  help?: string
  pillar: Pillar;

  constructor() {
    this.name = "";
    this.sections = [];
    this.version = 1;
    this.units = [];
    this.help = undefined;
    this.pillar = 0
    return this;
  }
}

// In case of a new section
export class Section implements ISection {
  id: string;
  title: string;
  next: string | null;
  components: IBaseComponent[];
  conditions?: ISectionCondition[];

  constructor(id: string = '', next: string | null = null) {
    this.id = Math.random().toString(36).substr(2, 9);
    this.title = ''
    this.next = next;
    this.components = [];
    return this;
  }
}

export default class FormflowComponent extends React.Component<IFormflowContainerProps, IFormflowContainerState> {

  //#region
  private _formflowService: ProcessRequestsInterceptor;
  private _userService: UserService;
  private idUnit: string = ''

  constructor(props: IFormflowContainerProps) {
    super(props);
    this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))

    this._formflowService = new ProcessRequestsInterceptor();
    this._userService = new UserService();

    this.getProcess = this.getProcess.bind(this);

    this.state = {
      currentComponent: null,
      currentSection: null,
      footerShow: false,
      formflow: new Formflow(),
      formflowSections: [new Section()],
      isComponentModalOpen: false,
      isLoaded: false,
      linkedModalVisible: false,
      quillContent: '<p>',
      title: '',
      valueRadio: 1,
      visibleModalRemoveSection: false,
      updateComponent: null,
      modalConditionVisible: false,
      isSaved: false,
      conditionIsBroken: false,
      redirect: false,
      minAuditedsByAuditor: '',
      maxAuditedsByAuditor: '',
      auditedGoal: {
        times: 1,
        type: FrequencyType.MONTHS,
      },
      auditorGoal: {
        times: 1,
        type: FrequencyType.MONTHS,
      },
      tableUsers: [],

    };

  }

  componentDidMount() {
    this.initialData()
  }

  initialData = async () => {
    if (this.props.match.params.id) {
      await this.getProcess(this.props.match.params.id);
    } else {
      this.setState({
        isLoaded: true
      })
    }

    await this.getUsers(true)
  }

  async getProcess(formflowId: string) {
    try {
      let formflow: any = undefined;
      switch (localStorage.getItem(LocalStorageKeys.PILLAR)) {
        case PillarNames.EHSS.toString():
          formflow = await this._formflowService.getById<IProcessEHSS>(formflowId, this.idUnit);
          let auditedGoal = {}
          if (formflow.auditedGoal && formflow.auditedGoal.type && formflow.auditedGoal.times) {
            auditedGoal = await {
              type: formflow.auditedGoal.type,
              times: formflow.auditedGoal.times,
            }
          }
          this.setState({
            minAuditedsByAuditor: formflow.minAuditedsByAuditor || 1,
            maxAuditedsByAuditor: formflow.maxAuditedsByAuditor || 1,
            auditedGoal: auditedGoal,
          });
          break;
        case PillarNames.QA.toString():
          formflow = await this._formflowService.getById<IProcess>(formflowId, this.idUnit);
          break;

        case PillarNames.LI.toString():
          formflow = await this._formflowService.getById<IProcess>(formflowId, this.idUnit);
          break;
      }
      this.setState({
        formflow,
        formflowSections: formflow.sections,
        sectionsSize: formflow.sections.length,
      })

      this.props.form.setFieldsValue(
        {
          input: this.state.formflow.name
        });
    }
    catch (e) {
      console.log("formflow error", e);
    }

    this.setState({
      isLoaded: true
    });
  }

  getUsers = async (reset: boolean, search?: string) => {
    // this.setState({ showFormModal: false, loadingMoreAssigners: true });
    const { tableUsers } = this.state;

    if (reset) {
      this.setState({
        curOffset: undefined,
        // showFormModal: false,
        // isLoading: true,
      });
    }
    try {
      const dataTableCreate: any = [];
      const data = await this._userService.paging({
        unit: this.idUnit,
        to: undefined,
        from: undefined,
        search: search,
        limit: 6,
        offset: this.state.curOffset
      });

      data.items.map((user: any, index: number) => {
        const _tableData = {
          key: user.id,
          id: user.id,
          name: user.name,
          username: user.username,
        };
        dataTableCreate.push(_tableData);
      });
      let newDataTableCreate: any = [];

      if (data !== undefined) {
        if (!reset) {
          newDataTableCreate = tableUsers || [];
        }
        newDataTableCreate = newDataTableCreate.concat(dataTableCreate);
      }



      this.setState({
        tableUsers: newDataTableCreate,
        curOffset: data.offset,
        // loadingMoreAssigners: false,
      });

    } catch (error) {
      console.warn(error);
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.searchUser"), error);
    }
  };

  loadMoreUsers = async () => {
    this.getUsers(false);
  }

  handleUsersSearch = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;

    this.setState({
      // loadingUsersBySearch: true,
      searchUser: SearchValue,
    })
    try {
      this.getUsers(true, SearchValue);
    }
    catch (err) {
      console.log(err)
    }
  };


  handleFormflowUpdateOnDatabase = async () => {
    let validationToSave: boolean[] = []
    for (let sectionsItems of this.state.formflowSections) {
      if (this.state.formflow.name === '' || sectionsItems.components && sectionsItems.components.length === 0 || sectionsItems.id === '') {
        validationToSave.push(false)
      }
      else {
        validationToSave = []
      }
    }
    if (validationToSave.length === 0) {
      try {
        const pillar: any = localStorage.getItem(LocalStorageKeys.PILLAR);
        if (this.state.formflow.id && pillar) {
          switch (pillar.toString().toLowerCase()) {
            case PillarNames.EHSS.toString().toLowerCase():
              const { auditedGoal } = this.state;
              const formflowData: IProcessEHSS = {
                ...this.state.formflow,
                minAuditedsByAuditor: parseInt(this.state.minAuditedsByAuditor),
                maxAuditedsByAuditor: parseInt(this.state.maxAuditedsByAuditor),
                auditedGoal: auditedGoal,
              }
              data = await this._formflowService.updateById<IProcessEHSS>(String(this.state.formflow.id), this.idUnit, formflowData)
              break;
            default:
              data = await this._formflowService.updateById(String(this.state.formflow.id), this.idUnit, this.state.formflow)
              break;
          }
          NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("formflow.labels.formflowSucess"));
        }
        else {
          switch (pillar.toString().toLowerCase()) {
            case PillarNames.EHSS.toString().toLowerCase():
              const { auditedGoal } = this.state;

              const formflowData: IProcessEHSS = {
                ...this.state.formflow,
                minAuditedsByAuditor: parseInt(this.state.minAuditedsByAuditor),
                maxAuditedsByAuditor: parseInt(this.state.maxAuditedsByAuditor),
                auditedGoal: auditedGoal,
              }
              await this._formflowService.create<IProcessEHSS>(formflowData, this.idUnit);
              break;
            default:
              await this._formflowService.create(this.state.formflow, this.idUnit);
              break;
          }
          NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("formflow.labels.formflowSucess"));
        }
        // window.location.assign = (Routes.formflowProcess);

        this.setState({ redirect: true });
      }
      catch (error) {
        NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), error.length > 0 ? error[0] : error);
      }
    }
    else {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), I18n.l("formflow.errors.save"));
    }

  }

  printValidation() {
    const sectionFormflowValidation: JSX.Element[] = [];
    let idx: number = 1;
    for (let section of this.state.formflowSections) {
      if (section.components && section.components.length === 0) {
        sectionFormflowValidation.push(
          <li>{I18n.l("formflow.labels.section") + ' ' + (idx)}</li>
        )
      }
      idx = idx + 1;
    };
    if (sectionFormflowValidation.length > 0) {
      return (
        <div className="validate-box" >
          <p className="validate-fontstyle" >{I18n.l("formflow.validation.sectionsIncomplete")}</p>
          <ul>{sectionFormflowValidation}</ul>
        </div>
      )
    }
    return
  }

  handleQuillChange = async (evt: any) => {
    const formflow: IProcess = this.state.formflow;
    formflow.help = evt;
    this.setState({
      formflow
    });
  }

  handleTitleChange = async (evt: any) => {
    this.setState({ title: evt.target.value });
  }

  handleInputTitleChange = (idx: any) => (evt: any) => {
    const newFormflowSections = this.state.formflowSections.map((section: ISection, sidx: number) => {
      if (idx !== sidx) return section;
      return { ...section, id: evt.target.value };
    });
    const formflow: IProcess = this.state.formflow;
    formflow.sections = newFormflowSections;
    this.setState({
      formflowSections: newFormflowSections,
      formflow
    });
  }

  handleAddNewSection = async () => {
    this.setState({
      footerShow: true,
      formflowSections: this.state.formflowSections.concat([new Section()]),
      sectionsSize: this.state.formflowSections.length + 1,
    });
    const newFormflow = Object.assign({}, this.state.formflow);
    newFormflow.sections = this.state.formflowSections

    this.setState({ formflow: newFormflow })

  }

  handleRemoveSection = (index: number, section: ISection) => async () => {

    if (section.conditions !== null && section.conditions !== undefined) {
      for (let sectionsItems of this.state.formflowSections) {

        if (sectionsItems.conditions !== null && sectionsItems.conditions !== undefined) {
          for (let conditions of sectionsItems.conditions)
            if (conditions.sectionId === section.id) {
              conditions.sectionId = undefined
            }
        }
      }
    }
    this.setState({
      formflowSections: this.state.formflowSections.filter((section: any, sindex: number) => index !== sindex),
      sectionsSize: this.state.formflowSections.length - 1,
      isComponentModalOpen: false,
    });
    const newFormflow = Object.assign({}, this.state.formflow);
    newFormflow.sections = await this.state.formflowSections
    this.setState({ formflow: newFormflow })
  }

  toggleLinkedModal = async () => {
    this.setState({ linkedModalVisible: !this.state.linkedModalVisible });
  }

  getSectionsSelect(idxTitle: any) {
    const selectTitles: string[] = [];

    this.state.formflowSections.forEach((section) => {
      if (section.id) {
        selectTitles.push(section.id);
      }

      const indexSelectSection = selectTitles.findIndex((idTitle: string) => idTitle === idxTitle)

      if (indexSelectSection > -1) {
        selectTitles.splice(indexSelectSection)
      }
    })
    return selectTitles;
  }

  getComponentsSelect() {
    const componentsTitle: string[] = [];
    this.state.formflowSections.forEach((section: any) => {
      if (section !== undefined) {
        section.components.forEach((idComponent: any) => {
          componentsTitle.push(idComponent)
        })
      }
    })
    return componentsTitle;
  }

  showModalRemoveSection() {
    this.setState({ visibleModalRemoveSection: !this.state.visibleModalRemoveSection });
  }

  onFormflowNameChange = (value: any) => {
    const formflow: IProcess = this.state.formflow;
    formflow.name = value.target.value;
    this.setState({
      formflow
    });
  }

  openModal = async () => {
    this.setState({ isComponentModalOpen: !this.state.isComponentModalOpen });
  }

  setCurrentComponent = async (nextComponent: IBaseComponent, currentSection: ISection) => {
    this.setState({
      isComponentModalOpen: true,
      currentComponent: nextComponent,
      currentSection
    });
  }

  setComponentsInSection = async (components: IBaseComponent[], section: ISection) => {
    const currentSection = section;
    currentSection.components = components;

    this.setState({
      currentSection
    });
  }

  setCurrentSection = async (currentSection: ISection) => {
    this.setState({
      currentSection
    });
  }

  destroyComponentModalWindow = () => {
    this.setState({
      isComponentModalOpen: false,
      currentComponent: null
    });
  }

  //#endregion

  removeComponentFromFormflow = async (componentToRemove: IBaseComponent, currentSection: ISection) => {
    if (!currentSection.components) return;

    this.setState({
      isLoaded: false
    });
    const sectionConditions: any = currentSection
    const formflowToUpdate = this.state.formflow;
    const sectionsToUpdate = this.state.formflowSections;
    //updates components
    const newComponents = currentSection.components.filter(x => x.id !== componentToRemove.id);
    const sectionIndex = sectionsToUpdate.findIndex(x => x.id === currentSection.id);

    if (sectionConditions.conditions !== undefined && sectionConditions.conditions !== null) {
      for (let conditions of sectionConditions.conditions) {
        for (let rules of conditions.rules) {
          if (rules.xItem.id === componentToRemove.id) {
            rules.xItem.id = undefined
          }
        }
      }
    }

    if (sectionIndex !== -1) {
      sectionsToUpdate[sectionIndex].components = newComponents;
      sectionsToUpdate[sectionIndex].conditions
      formflowToUpdate.sections = sectionsToUpdate;
    }

    this.setState({
      formflow: formflowToUpdate,
      formflowSections: sectionsToUpdate,
      isLoaded: true
    });
    console.log('valot do component atual', this.state.formflow)
  }

  updateFormflowWithComponent = async (updatedComponent: IBaseComponent) => {

    let currentSections = this.state.formflowSections;
    let _sectionIndex: number = -1;
    let _componentIndex: number = -1;

    currentSections.forEach((section: ISection, sectionIndex: number) => {
      if (section.components) {
        section.components.forEach((component: any, componentIndex: number) => {
          if (component.id === updatedComponent.id) {
            _componentIndex = componentIndex;
            _sectionIndex = sectionIndex;
          }
        });

        if (updatedComponent.id === '' && section === this.state.currentSection) {
          _sectionIndex = sectionIndex;
          updatedComponent.id = section.id + '_C' + Date.now()
          section.components.push(updatedComponent)
        }
      }
    });

    if (_sectionIndex !== -1 && _componentIndex !== -1 && currentSections[_sectionIndex].components !== undefined) {
      currentSections[_sectionIndex].components[_componentIndex] = updatedComponent;

      const formflow: IProcess = this.state.formflow;
      formflow.sections = currentSections;
      this.setState({
        formflowSections: currentSections,
        formflow: formflow
      });
      console.log('valor do novo', this.state.formflow)

    }
    else {
      const formflow: IProcess = this.state.formflow;
      formflow.sections = currentSections;
      this.setState({
        formflowSections: currentSections,
        formflow: formflow
      });
    }
    console.log('AFTER SAVE', currentSections)

    await console.log('valor do forflow', this.state.formflow)

    this.destroyComponentModalWindow();
  }

  updateFormflowWithCondition = async (updatedConditions: any, currentSection: ISection) => {

    let sectionsConditions = this.state.formflowSections;
    let _sectionIndex: number = -1;

    sectionsConditions.map((sections: ISection, sectionId: number) => {
      if (sections.id === currentSection.id) {
        _sectionIndex = sectionId;
      }
    })
    // currentSectionToUpdate = sectionsConditions.find((sectionCurrent: ISection) => sectionCurrent.id === currentSection.id)
    if (_sectionIndex !== -1) {
      sectionsConditions[_sectionIndex].conditions = updatedConditions;
      const formflow: IProcess = this.state.formflow;
      formflow.sections = sectionsConditions;

      this.setState({
        formflowSections: sectionsConditions,
        formflow: formflow
      });
      console.log('seção igual', this.state.formflow)
    }
  }

  updateFormflowApproverUsers = async (updatedApprovers: any, currentSection: ISection) => {

    let sections = this.state.formflowSections;
    let _sectionIndex: number = -1;
    console.log('current section', currentSection)


    sections.map((sections: ISection, sectionId: number) => {
      if (sections.id === currentSection.id) {
        _sectionIndex = sectionId;
      }
    })
    console.log('_sectionIndex', _sectionIndex)

    if (_sectionIndex !== -1) {
      sections[_sectionIndex].approverUsers = updatedApprovers;
      const formflow: IProcess = this.state.formflow;
      formflow.sections = sections;

      this.setState({
        formflowSections: sections,
        formflow: formflow
      });
    }
    console.log('seção igual', this.state.formflow)
  }

  sectionLinkOnChange = (idx: number) => async (evt: any) => {
    const newSection = Object.assign({}, this.state.formflowSections);
    if (evt === 'end') {
      newSection[idx].next = null
    }
    else {
      newSection[idx].next = evt
    }
    this.setState({ formflowSections: this.state.formflowSections })
  }

  conditionIsbroken(sectionConditions: any) {
    let sectionConditionValidation: boolean = false
    if (sectionConditions !== null && sectionConditions !== undefined) {
      for (let conditions of sectionConditions) {
        for (let rules of conditions.rules) {
          if (rules.xItem.id === undefined) {
            sectionConditionValidation = true
          }
        }
      }
      for (let sectionsItems of this.state.formflowSections) {
        if (sectionsItems.conditions !== null && sectionsItems.conditions !== undefined) {
          for (let conditions of sectionsItems.conditions)
            if (conditions.sectionId === undefined) {
              sectionConditionValidation = true
            }
        }
      }
    }

    if (sectionConditionValidation) {
      return (
        <FontAwesomeIcon className="exclamation-avatar" icon="exclamation-circle" />
      )
    }
    return
  }

  handleAuditedGoalsTimesChange = async (value: any) => {
    this.setState({ auditedGoal: { ...this.state.auditedGoal, times: value } });
  }

  handleAuditedGoalsTypesChange = async (evt: any) => {
    this.setState({ auditedGoal: { ...this.state.auditedGoal, type: evt.target.value } });
  }

  handleMinAuditedByAuditorChange = async (value: any) => {
    this.setState({
      minAuditedsByAuditor: Number(value),
    });
  }

  handleMaxAuditedByAuditorChange = async (value: any) => {
    this.setState({
      maxAuditedsByAuditor: Number(value),
    });
  }

  renderConfigAudit() {

    if (localStorage.getItem(LocalStorageKeys.PILLAR).toString().toLowerCase() == PillarNames.EHSS.toString().toLowerCase()) {
      const { getFieldDecorator } = this.props.form;
      return (
        <Form>
          <FormItem>
            {getFieldDecorator('minAuditedsByAuditor', {
              rules:
                [
                  { required: true, message: I18n.l("form.validation.field.required") },
                ],
              initialValue: this.state.minAuditedsByAuditor,
            })(
              <div>
                <p style={{ marginTop: "3rem" }}>{I18n.l('auditconf.minAuditedsByAuditor')}</p>
                <InputNumber style={{ width: "100%" }}
                  defaultValue={this.state.minAuditedsByAuditor}
                  onChange={this.handleMinAuditedByAuditorChange}
                  min={1}
                />

              </div>
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator('maxAuditedsByAuditor', {
              rules:
                [
                  { required: true, message: I18n.l("form.validation.field.required") },
                ],
              initialValue: this.state.maxAuditedsByAuditor
            })(
              <div>
                <p>{I18n.l('auditconf.maxAuditedsByAuditor')}</p>
                <InputNumber style={{ width: "100%" }}
                  defaultValue={this.state.maxAuditedsByAuditor}
                  onChange={this.handleMaxAuditedByAuditorChange}
                  min={1}
                />

              </div>
            )}
          </FormItem>

          <FormItem>
            {getFieldDecorator('auditedgoalstimes', {
              rules:
                [
                  { required: true, message: I18n.l("form.validation.field.required") },
                ],
              initialValue: this.state.auditedGoal.times
            })(
              <div className={'audit-config'}>
                <p>{I18n.l('auditconf.auditedgoalstimes')}</p>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <InputNumber style={{ width: "100%" }}
                    defaultValue={this.state.auditedGoal.times}
                    onChange={this.handleAuditedGoalsTimesChange}
                    min={1}
                  />
                  <span className={'per-field-container'}>{I18n.l('auditconf.per')}</span>
                  <Radio.Group defaultValue={this.state.auditedGoal.type} onChange={this.handleAuditedGoalsTypesChange} className={'button-group-container'}  >
                    <Radio.Button value={FrequencyType.MONTHS | 2}>{I18n.l('auditconf.goalsmonth')}</Radio.Button>
                    <Radio.Button value={FrequencyType.YEARS | 3}>{I18n.l('auditconf.goalsyears')}</Radio.Button>
                  </Radio.Group>
                </div>
              </div>
            )}
          </FormItem>
        </Form>
      );
    }

    return;

  }

  render() {
    const { getFieldDecorator } = this.props.form;
    console.log(this.state)
    return (

      <Page>

        <Wrapper>
          <FormflowContext.Provider
            value={{
              isComponentModalOpen: this.state.isComponentModalOpen,
              currentComponent: this.state.currentComponent,
              currentSection: this.state.currentSection,
              setCurrentComponent: this.setCurrentComponent,
              destroyComponentModalWindow: this.destroyComponentModalWindow,
              sections: this.state.formflowSections,
              updateFormflowWithComponent: this.updateFormflowWithComponent,
              updateFormflowWithCondition: this.updateFormflowWithCondition,
              updateFormflowApproverUsers: this.updateFormflowApproverUsers,
              removeComponentFromFormflow: this.removeComponentFromFormflow,
              removeSectionFormflow: this.handleRemoveSection,
              openModal: () => this.openModal(),
              setComponentsInSection: this.setComponentsInSection
            }}
          >
            {!this.state.isLoaded &&
              I18n.l("common.loadingData")
            }

            {this.state.isLoaded &&
              <React.Fragment>
                {this.renderConfigAudit()}
                {this.state.redirect &&
                  <Redirect
                    push
                    to={Routes.formflowProcess}
                    from={`${Routes.componentFormflow}/${this.state.formflow.id}`}
                    strict
                  />
                }
                <QuillHtmlComponent
                  defaultValue={this.state.formflow.help}
                  placeholder={I18n.l("form.placeholders.textComponentMulti")}
                  title={I18n.l("titles.insertGuide")}
                  description={I18n.l("auditconf.auditInstructions")}
                  onTextChange={this.handleQuillChange} />
                {this.printValidation()}
                <Spacing />
                <p><strong>{I18n.l("formflow.labels.description")}</strong></p>
                <p><strong>{I18n.l("formflow.labels.subdescription")}</strong></p>

                <Form onSubmit={this.handleFormflowUpdateOnDatabase}>
                  <FormItem
                  >
                    {getFieldDecorator('input', {
                      rules:
                        [
                          { required: true, message: I18n.l("form.validation.field.required") },
                          {
                            min: 3, message: I18n.l('formflow.labels.validationToShort')
                          },
                        ],
                      initialValue: this.state.formflow.name

                    })(
                      <div>
                        <p style={{ marginTop: "3rem" }}>{I18n.l("formflow.labels.nameThisFormflow")}</p>
                        <Input style={{ width: "100%" }}
                          defaultValue={this.state.formflow.name}
                          onChange={this.onFormflowNameChange}
                          className={this.state.formflow.name.length === 50 ? "apply-shake" : ''}
                          maxLength={50}
                          minLength={3}
                        />

                      </div>

                    )}
                  </FormItem>
                  <p style={{ float: 'right' }} className={this.state.formflow.name.length < 50 ? "count-input" : "count-input-red"} >
                    {this.state.formflow.name.length !== 0 ? this.state.formflow.name.length + ' / 50' : '0 / 50'}
                  </p>
                </Form>

                {this.state.formflowSections.map((section: ISection, idx: number) => (
                  <React.Fragment key={idx}>

                    {(section.components !== undefined) &&
                      <SectionComponent
                        key={idx}
                        closeModal={this.state.modalConditionVisible !== undefined ? this.state.modalConditionVisible : true}
                        conditionIsBroken={this.conditionIsbroken(section.conditions)}
                        currentSection={section}
                        defaultValueInput={section.id}
                        footerShow={this.state.footerShow}
                        idxSection={idx + 1}
                        inputValue={section.id !== undefined ? section.id : ''}
                        isComponentModalOpen={this.state.isComponentModalOpen}
                        modalRemoveSection={() => this.showModalRemoveSection()}
                        onClickLinkedButton={() => this.toggleLinkedModal}
                        onClickRemoveButton={() => this.handleRemoveSection(idx, section)}
                        onInputChange={() => this.handleInputTitleChange(idx)}
                        sectionComponents={section.components}
                        sectionConditions={section.conditions}
                        sectionLinked={this.getSectionsSelect(section.id)}
                        sectionLinkedSelect={section.next}
                        sizeSection={this.state.sectionsSize}
                        titleSection={I18n.l("formflow.labels.section") + " " + (idx + 1)}
                        valueIDSection={section.id !== undefined ? section.id : ''}
                        visibleRemoveModal={this.state.visibleModalRemoveSection}
                        sectionLinkOnChange={() => this.sectionLinkOnChange(idx)}
                        tableApproverUsers={this.state.tableUsers}
                        approversUsers={section.approverUsers ? section.approverUsers : []}
                        loadMoreUsers={this.loadMoreUsers}
                        curOffset={this.state.curOffset}
                        handleUsersSearch={this.handleUsersSearch}
                      />
                    }
                  </React.Fragment>
                ))}
                {this.state.isComponentModalOpen && this.state.currentComponent && (
                  <FormflowComponentsModal />
                )}


                <Button style={{ marginLeft: '40%' }} onClick={this.handleAddNewSection} className="goepik-btn-border-main">
                  <Icon type="plus" /> {I18n.l("formflow.buttons.createNewSection").toUpperCase()}
                </Button>
                <ButtonStyle>
                  <Row type="flex" justify="end">
                    <Button className="button-save " type="primary" onClick={this.handleFormflowUpdateOnDatabase}>{I18n.l('common.save')}</Button>
                  </Row>
                </ButtonStyle>
              </React.Fragment>
            }
          </FormflowContext.Provider>
        </Wrapper>
      </Page>
    );
  }
}

//#region CSS
const Wrapper = styled.div`
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    .count-input{
        margin-top:2px;
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
    }
    .validate-box{
      margin-top: 30px;
      width: 100%;
      height: 100px;
      background: ${Theme.secondary.red};
      padding: 25px;
      color: ${Theme.secondary.white};
      .validate-fontstyle{
        font-weight: bold;
      }
      ul {
        padding: 0;
        li {
          margin: 0;
          padding: 3px 0;
          list-style: none;
        }
      }
    }
    .count-input-red{
        margin-top:2px;
        color: ${Theme.secondary.red};
        font-weight: bold;
    }
    @keyframes shake {
        10%, 90% {
            transform: translate3d(-1px, 0, 0);
        }
      
        20%, 80% {
            transform: translate3d(2px, 0, 0);
        }
      
        30%, 50%, 70% {
            transform: translate3d(-4px, 0, 0);
        }
      
        40%, 60% {
            transform: translate3d(4px, 0, 0);
        }
    }

    .apply-shake {
        animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
    }

    .audit-config{
      .per-field-container{
        margin-left:10px;
      }
      .button-group-container {
        margin-left: 10px;
        width: 100%;
      }
    }
`;
const Spacing = styled.div`
    margin-top: 4rem;
`;


const ButtonStyle = styled.div`
    float:right;
    margin-top: 5vh;
    margin-bottom: 5vh;
    margin-right: 50px;
    
    .button-save{
        bottom: 5%;
        width: 6rem;
    }
    .button-cancel{
        bottom: 5%;
        width: 6rem;
        margin-left: -6.5rem;
    }
    .hide-button {
      display: none;
    }
`;

//#endregion
export const FormflowComponentSections = Form.create()(FormflowComponent);